import { useMemo, useEffect } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"

import { useUI } from "providers/UIProvider"
import { useDistrictsContext } from "providers/DistrictsProvider/DistrictsProvider"
import { IDistrict } from "types/district"

const INITIAL_VALUES = {
  name: "",
}

const SCHEMA = (T: any) =>
  Yup.object({
    name: Yup.string().required("უბანი აუცილებელია"),
  })

const useDistricts = (districtData?: IDistrict | null) => {
  const { toggleModal } = useUI()
  const { addDistrict, updateDistrict, deleteDistrict } = useDistrictsContext()

  const editMode = districtData ? true : false

  const handleAddDistrict = () => {
    toggleModal("addEditDistrictModal", true)
  }

  const handleEditDistrict = (newDistrict: IDistrict) => {
    toggleModal("addEditDistrictModal", true, newDistrict)
  }

  const handleAddEditDistrictSubmit = (values: any) => {
    if (editMode && districtData) {
      updateDistrict({ id: districtData!.id, name: values.name })
    } else {
      addDistrict({ name: values.name })
    }
  }

  const handleDeleteDistrict = (district: IDistrict) => {
    toggleModal("confirmationModal", true, {
      title: `დარწმუნებული ხართ, რომ გსურთ, ${district.name}, უბნის წაშლა`,
      handleSubmit: () => deleteDistrict(district.id),
    })
  }

  const {
    values,
    errors,
    touched,
    handleBlur,
    setValues,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: SCHEMA,
    onSubmit: handleAddEditDistrictSubmit,
  })

  useEffect(() => {
    if (editMode && districtData) {
      setValues({ name: districtData.name })
    }
  }, [districtData])

  return useMemo(
    () => ({
      form: {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm,
      },
      handleAddDistrict,
      handleEditDistrict,
      handleDeleteDistrict,
    }),
    [values, errors, touched, handleChange, handleBlur, resetForm],
  )
}

export default useDistricts
